module.exports = {"$schema":"http://iglucentral.com/schemas/com.snowplowanalytics.self-desc/schema/jsonschema/1-0-0#","self":{"vendor":"com.codecombat","name":"heard_sprite","format":"jsonschema","version":"1-0-0"},"type":"object","properties":{"user":{"type":"string","pattern":"^[a-z0-9]{24}$","maxLength":24,"minLength":24},"ls":{"type":"string","pattern":"^[a-z0-9]{24}$","maxLength":24,"minLength":24},"message":{"type":"string"}},"required":["user","ls"],"additionalProperties":false}


//////////////////
// WEBPACK FOOTER
// ./app/schemas/events/heard_sprite.json
// module id = 537
// module chunks = 100